const React       = require('react');

const Spinner = ({ size }) => {
    return <div className="spinner" style={{ width: `${size}px`, height: `${size}px`}}></div>
}; // RulesRequestStats

module.exports = Spinner;
